import { useQuery } from '@tanstack/react-query';

import { facebookQueries } from './queries';

export function useGetFacebookPages(pharmacyId: string | undefined) {
  const { data: pages, isPending } = useQuery(
    facebookQueries.pages(pharmacyId)
  );

  return { pages, isPending };
}
